import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { fullscreenLayerHidden, fullscreenLayerShown } from '../state/slice';

/**
 * For a full-screen camera layer that covers the header: while `active`, the connection banner
 * moves to the top edge of the screen, over the camera.
 */
export const useFullscreenLayer = (active) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (!active) return undefined;

        dispatch(fullscreenLayerShown());
        return () => dispatch(fullscreenLayerHidden());
    }, [active, dispatch]);
};
